import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  AssetSubscriptionDto,
  AssetSubscriptionReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AssetSubscriptionInline from "./AssetSubscriptionInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: AssetSubscriptionDto | AssetSubscriptionReferenceDto;
  entityId?: string | null;
}

export default function AssetSubscriptionLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AssetSubscriptionRead]}
      to={ROUTE_PATH.ASSET_SUBSCRIPTION_VIEW(entity?.id || "")}
      content={<AssetSubscriptionInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
